/* 
 * This file is part of Tibia Wheel.
 * Copyright (c) 2022 Maciej Sopyło
 * 
 * Tibia Wheel is free software: you can redistribute it and/or modify  
 * it under the terms of the GNU Lesser General Public License as published by  
 * the Free Software Foundation, version 3.
 *
 * Tibia Wheel is distributed in the hope that it will be useful, but 
 * WITHOUT ANY WARRANTY; without even the implied warranty of 
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU 
 * General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License 
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react';
import { RootContextProvider } from './context';
import { Wheel } from './components/Wheel';

import { VocationSelector } from './components/VocationSelector';
import { Summary } from './components/Summary';
import { Widget } from './components/Widget';
import { SelectionPanel } from './components/SelectionPanel';

import styles from './App.module.css';

export const App: React.FC = () => {
  return <div className={styles.shell}>
    <RootContextProvider>
      <main className={styles.planner}>
        <Wheel/>
        <aside className={styles.sidebar}>
          <Widget>
            <VocationSelector />
          </Widget>
          <SelectionPanel />
          <Summary />
        </aside>
      </main>
    </RootContextProvider>
  </div>;
};
